/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PersonalAdditionalController', PersonalAdditionalController);

    PersonalAdditionalController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate', 'DateUtils'];

    function PersonalAdditionalController (PrincipalProfile, Auth, AlertService, $translate, DateUtils) {

        var vm = this;

        vm.profile = null;
        vm.save = save;
        vm.idTypeChange = idTypeChange;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.idExpirationDate = false;

        vm.tomorrow = new Date();
        vm.tomorrow.setDate(vm.tomorrow.getDate() + 1);
        vm.startDate = new Date();
        vm.startDate.setMonth(vm.startDate.getMonth() + 2);
        vm.idDateOptions = {
            minDate: vm.tomorrow,
            initDate: vm.startDate
        };

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save () {
            vm.isSaving = true;
            if(vm.profile.weight === "") {
                vm.profile.weight = null;
            }
            if(vm.profile.clothingSize === "") {
                vm.profile.clothingSize = null;
            }
            if(vm.profile.shoeSize === "") {
                vm.profile.shoeSize = null;
            }
            if(vm.profile.nationality === "") {
                vm.profile.nationality = null;
            }
            if(vm.profile.countryOfBirth === "") {
                vm.profile.countryOfBirth = null;
            }
            if(vm.profile.idType === "") {
                vm.profile.idType = null;
            }
            if(vm.profile.isaf === "") {
                vm.profile.isaf = null;
            }
            var profile = angular.copy(vm.profile);
            profile.idExpirationDate = DateUtils.convertLocalDateToServer(profile.idExpirationDate);
            Auth.updateProfile(profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }

        function idTypeChange() {
            if(vm.profile.idType === "") {
                vm.profile.idNumber = "";
                vm.profile.idExpirationDate = "";
            }
        }
    }
})();
